import { createSelector } from 'reselect'

const getVendors = state => state.vendors

const googleVendorSelector = createSelector(
	[ getVendors ],
	vendors => vendors.google
)

export default googleVendorSelector
